import * as moment from 'moment';
import * as Models from '../../models';

import { IDateRangeService } from '../general/dateRange.service';
import { WidgetIntervalHelper } from '../../common/helpers/widgetIntervalHelper';

export interface IwidgetIntervalHelperService {
    getInterval(beginDate: string, endDate: string, configuration: Models.IPeriodConfiguration): { beginMoment: moment.Moment, endMoment: moment.Moment };
    getCurrentInterval(): { beginDate: string, endDate: string };
    getCurrentInterval(configuration: Models.IPeriodConfiguration): { beginDate: string, endDate: string };
    getCurrentInclusiveInterval(): { beginDate: string, endDate: string };
}

export class WidgetIntervalHelperService implements IwidgetIntervalHelperService {
    static serviceId = 'widgetIntervalHelperService';
    static $inject = ['dateRangeService'];

    private _helper: WidgetIntervalHelper;

    constructor(private _dateRangeService: IDateRangeService) {
        this._helper = new WidgetIntervalHelper();
    }

    getInterval(beginDate: string, endDate: string, configuration: Models.IPeriodConfiguration): { beginMoment: moment.Moment, endMoment: moment.Moment } {
        const duration = moment.duration(1, 's');
        return this._helper.getInterval(beginDate, endDate, configuration, duration);
    }

    getCurrentInclusiveInterval(): { beginDate: string; endDate: string } {
        let beginDate = this._dateRangeService.beginDate() as string;
        let endDate = this._dateRangeService.endDate() as string;
        const configuration = {
            isEndDateIncluded: true,
            minPeriod: undefined,
            maxPeriod: undefined
        };
        const updatedInterval = this.getInterval(beginDate as string, endDate as string, configuration);
        beginDate = updatedInterval.beginMoment.toISOString();
        endDate = updatedInterval.endMoment.toISOString();
        return {
            beginDate: beginDate,
            endDate: endDate
        };
    }

    getCurrentInterval(configuration?: Models.IPeriodConfiguration): { beginDate: string;endDate: string } {
        let beginDate = this._dateRangeService.beginDate() as string;
        let endDate = this._dateRangeService.endDate() as string;
        if (!configuration) {
            configuration = {
                isEndDateIncluded: false,
                minPeriod: undefined,
                maxPeriod: undefined
            };
        }
        const updatedInterval = this.getInterval(beginDate, endDate, configuration);
        beginDate = updatedInterval.beginMoment.toISOString();
        endDate = updatedInterval.endMoment.toISOString();
        return {
            beginDate: beginDate,
            endDate: endDate
        };
    }
}
